<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <img src="/Content/svg/client-logo.svg" class="ir-logo" />
    </div>
    <div class="ir-line--right"></div>
    <div class="ir-line-content">
      <span>{{ 'login.sign-in' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-content-fixed ir-mv2 th-content">
    <p class="th-txt">
      <span>{{ 'login.sign-in-start' | translate }}</span>
    </p>
    <div style="display: flex;" class="ir-mv16">
      <div style="flex:1;" class="ir-pr8">
        <p class="th-txt">
          <span>{{ 'login.external-users' | translate }}</span>
        </p>

        <form [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit(loginForm)">
          <table class="ir-login-table">
            <tr>
              <td>
                <h2>
                  <span>{{ 'login.login' | translate }}</span>
                </h2>
              </td>
              <td>
                <div class="ir-form-group">
                  <validation-message *ngIf="loginForm.controls.password.value"
                    [validationControl]="loginForm.controls.username" [validationName]="'required'"
                    [errorMessage]="'common.required' | translate">
                  </validation-message>
                  <input formControlName="username" class="ir-form-set" placeholder="{{ 'login.login' | translate }}" />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <h2>
                  <span>{{ 'login.password' | translate }}</span>
                </h2>
              </td>
              <td>
                <div class="ir-form-group">
                  <validation-message *ngIf="loginForm.controls.username.value"
                    [validationControl]="loginForm.controls.password" [validationName]="'required'"
                    [errorMessage]="'common.required' | translate">
                  </validation-message>
                  <input formControlName="password" class="ir-form-set" type="password"
                    placeholder="{{ 'login.password' | translate }}" />
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p *ngIf="isLoginFailed" class="th-txt--error">
                  <span>{{ 'login.invalid' | translate }}</span>
                </p>
              </td>
            </tr>
            <tr>
              <td>
              </td>
              <td>
                <button class="ir-btn ir-btn--big ir-btn--block th-btn-action" type="submit"
                  [disabled]="loginForm.invalid || loading">
                  <span>{{ 'login.sign-in' | translate }}</span>
                </button>
              </td>
            </tr>
          </table>


        </form>
      </div>
      <div style="flex:1; border-left: solid 1px #dde1e5;" class="ir-pl8"
        [style.display]="ssoEnabled ? 'block' : 'none'">
        <p class="th-txt">
          <span>{{ 'login.bobst-users' | translate }}</span>
        </p>
        <div style="margin-top: 9em; width:70%">
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-action" (click)="bobstAccess()">
            <span>{{ 'login.bobst-access' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>

</div>